export default __webpack_public_path__ + "a25bb8b411b9a1b7120397cb283e9b86.png";